import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ErrorSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ErrorSVG;
